import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button as AntdButton, Flex, Form, Upload, message, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../../../components/common/Icon';
import { createMap3DObjectAction, getMap3DObjectsAction } from '../../../../../store/mapObjectSlice';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../../../editor.style';
const initialValues = {
    name: '',
    iconFromDefaultList: '',
    sortOrder: 1,
    color: null,
    externalId: '',
    imageUrl: [],
};
const ThreeDObjectFormPanel = ({ isOpen, onBack }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [container, setContainer] = useState(null);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const creating = false;
    const uploadProps = {
        accept: '.zip',
        customRequest: (options) => {
            options.onSuccess?.('ok');
        },
        beforeUpload: (file) => {
            if (!file.name.toLowerCase().endsWith('.zip')) {
                message.error('Only zip files are allowed!');
                return Upload.LIST_IGNORE;
            }
            return false;
        },
        onChange: (info) => {
            const newFileList = info.fileList.slice(-1);
            if (newFileList.length > 0) {
                const fileObj = newFileList[0].originFileObj;
                form.setFieldValue('objectUpload', fileObj);
            }
            else {
                form.setFieldValue('objectUpload', null);
            }
        },
    };
    const onFinish = (values) => {
        if (siteId) {
            try {
                const formData = new FormData();
                formData.append('mapObjectFile', values.objectUpload);
                dispatch(createMap3DObjectAction({ siteId: siteId, name: values.name, mapObjectFile: formData })).then(() => {
                    dispatch(getMap3DObjectsAction(siteId));
                    message.success('3D object uploaded successfully');
                    form.resetFields();
                    onBack();
                });
            }
            catch (error) {
                message.error('File upload failed');
            }
        }
    };
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { isOpen: isOpen, style: {
                width: '340px',
            }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                            onBack();
                                            form.resetFields();
                                        } }), _jsx("h3", { children: 'Add New 3D Object' })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsxs(Form, { initialValues: initialValues, form: form, layout: "vertical", onFinish: async (values) => {
                                    onFinish(values);
                                }, children: [_jsx(Form.Item, { name: "name", label: "Name", required: true, tooltip: "This is a required field", rules: [{ required: true, message: 'Name is required' }], children: _jsx(Input, { placeholder: "File Name", variant: "filled" }) }), _jsx(Form.Item, { name: "objectUpload", label: "3D Object zip file", rules: [{ required: true }], children: _jsxs(Upload.Dragger, { ...uploadProps, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(Icon, { icon: "upload", size: 24 }) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag zip file here to upload" })] }) })] }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { onClick: () => {
                                        onBack();
                                        form.resetFields();
                                    }, color: "danger", variant: "filled", children: "Cancel" }), _jsx(Button, { loading: creating, onClick: () => {
                                        form.submit();
                                    }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }) }));
};
export default React.memo(ThreeDObjectFormPanel);
